/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Process_Step_DocumentsInputs */

const en_input_process_step_documents = /** @type {(inputs: Input_Process_Step_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents`)
};

const nl_input_process_step_documents = /** @type {(inputs: Input_Process_Step_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documenten`)
};

/**
* | output |
* | --- |
* | "Documents" |
*
* @param {Input_Process_Step_DocumentsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const input_process_step_documents = /** @type {((inputs?: Input_Process_Step_DocumentsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Process_Step_DocumentsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_input_process_step_documents(inputs)
	return en_input_process_step_documents(inputs)
});